import useYotpoInit from '@root/src/hooks/useYotpoInit';

const YotpoReviewsBadge = () => {
  useYotpoInit();

  return <div id="y-badges" className="yotpo badge badge-init mt-32" suppressHydrationWarning></div>;
};

export default YotpoReviewsBadge;
